// extracted by mini-css-extract-plugin
export default {"onlyDark":"RootLayout_onlyDark__pbrLp","onlyLight":"RootLayout_onlyLight__LBUe+","main":"RootLayout_main__yqD-r"};